const initialState = {
  user_data: null,
  bearer_token: null,
  current_store: null,
  current_cart: [],
  rolesandpermission_data: null,
  userpermission_data: [],
  layoutstyledata: localStorage.getItem("layoutStyling") || "default",
};

export default initialState;
